import React, { useMemo } from "react";

// Components
import Modal from "components/organism/modal-v2";

// Assets
import { ReactComponent as XIcon } from "assets/cross.svg";
import IWhatsapp from "assets/i-whatsapp.js";

const Spec = ({ label, value, unit }) => {
  return (
    <div className="flex items-center gap-[4px] justify-between">
      <p className="text-[13px] font-inter text-[#808285]">{label}</p>
      <p className="text-[13px] font-inter text-[#252526] text-end">
        {value}
        {unit && <span dangerouslySetInnerHTML={{ __html: unit }} />}
      </p>
    </div>
  );
};

const ModalDetailCustomer = ({ onClose, isOpen, detailCustomer, ...props }) => {
  const formatSpec = useMemo(() => {
    const res = [];

    if (detailCustomer?.min_surface_area) {
      res.push({
        label: "Luas tanah (minimal)",
        value: detailCustomer?.min_surface_area,
        unit: "m<sup>2</sup>",
      });
    }

    if (detailCustomer?.min_building_area) {
      res.push({
        label: "Luas bangunan (minimal)",
        value: detailCustomer?.min_building_area,
        unit: "m<sup>2</sup>",
      });
    }

    if (detailCustomer?.min_price) {
      res.push({
        label: "Bugdet (minimal)",
        value: `Rp${parseInt(detailCustomer?.min_price).toLocaleString("ID-id")}`,
        unit: "",
      });
    }

    if (detailCustomer?.max_price) {
      res.push({
        label: "Bugdet (maximal)",
        value: `Rp${parseInt(detailCustomer?.max_price).toLocaleString("ID-id")}`,
        unit: "",
      });
    }

    if (detailCustomer?.bedroom) {
      res.push({
        label: "Jumlah kamar tidur",
        value: detailCustomer?.bedroom,
        unit: "",
      });
    }

    if (detailCustomer?.bathroom) {
      res.push({
        label: "Jumlah kamar mandi",
        value: detailCustomer?.bathroom,
        unit: "",
      });
    }

    return res;
  }, [detailCustomer]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} {...props}>
      <div
        className="w-[400px] z-[42] bg-white rounded-md border-[0.5px] border-solid border-[#ECECEC] 
        shadow-[0px_1px_3px_0px_rgba(16,16,16,0.10),_0px_1px_2px_0px_rgba(16,16,16,0.06)]"
      >
        <div className="flex justify-between px-4 py-2 border-b border-solid border-[#D8D8D9]">
          <p className="text-[17px] font-inter-semibold">
            Detail Profil Customer
          </p>

          <XIcon onClick={onClose} />
        </div>

        <div className="px-4 py-2 border-b-[0.5px] border-solid border-[#D8D8D9]">
          <p className="text-[13px] font-inter text-[#808285]">
            Info customer:
          </p>
          <p className="text-[13px] font-inter text-[#252526]">
            {detailCustomer?.name}
          </p>
          <p className="text-[13px] font-inter text-[#252526] flex items-center gap-[4px]">
            <IWhatsapp />
            {detailCustomer?.whatsapp_number}
          </p>
        </div>
        <div className="px-4 py-2 border-b-[0.5px] border-solid border-[#D8D8D9]">
          <p className="text-[13px] font-inter text-[#252526]">
            Sedang mencari{" "}
            <span className="font-inter-semibold">{detailCustomer?.type}</span>{" "}
            di:
          </p>

          <div className="flex flex-wrap gap-[4px]">
            {detailCustomer?.preferred_areas?.map((item, idx) => (
              <span
                key={idx}
                className="py-[0.5px] px-2 rounded-[4px] bg-[#E6E7E8] text-[11px] font-inter text-[#252526]"
              >
                {item?.name}, {item?.city_name}
              </span>
            ))}
          </div>
        </div>
        <div className="px-4 py-2">
          <p className="text-[11px] font-inter text-[#808285]">Spesifikasi</p>

          <div className="flex flex-col gap-[2px]">
            {formatSpec?.map((item, idx) => (
              <Spec
                key={idx}
                label={item.label}
                value={item.value}
                unit={item.unit}
              />
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

const Wrapper = ({ isOpen, ...props }) => {
  if (!isOpen) return null;
  return <ModalDetailCustomer isOpen={isOpen} {...props} />;
};

export default Wrapper;
